interface OffersStorage {
  offersIds: number[];
  engineId: number;
}

// Action pour ajouter des offres au local storage
export const addOffersToLocalStorage = (data: OffersStorage) => {
  localStorage.setItem("offersSelected", JSON.stringify(data));
};

// Action pour vider le tableau dans le local storage
export const clearOffersInLocalStorage = () => {
  localStorage.setItem("offersSelected", JSON.stringify({ offersIds: [], engineId: "" }));
};

// Action pour supprimer la variable du local storage
export const removeOffersFromLocalStorage = () => {
  localStorage.removeItem("offersSelected");
};

// Action pour charger les offres depuis le local storage
export const loadOffersFromLocalStorage = (): OffersStorage | null => {
  const storedData = localStorage.getItem("offersSelected");
  return storedData ? JSON.parse(storedData) : null;
};

// Fonction pour vérifier si l'objet existe dans le local storage
export const doesOffersExistInLocalStorage = (): boolean => {
  const storedData = localStorage.getItem("offersSelected");
  return storedData !== null;
};
